import React from 'react';

const OrDivider = () => {
  return (
    <div className="aud-v2-or-divider">
      <div className="aud-v2-or-divider__line" />
      <span className="aud-v2-or-divider__text">OR</span>
      <div className="aud-v2-or-divider__line" />
    </div>
  );
};

export default OrDivider;
